export default __webpack_public_path__ + "static/media/product.1797bc73.png";